import { render, staticRenderFns } from "./MyResult.vue?vue&type=template&id=bcd00c8c&scoped=true&"
import script from "./MyResult.vue?vue&type=script&lang=js&"
export * from "./MyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd00c8c",
  null
  
)

export default component.exports